import React from 'react';

import { Link } from 'gatsby';

import ThemeToggle from './ThemeToggle';

const Footer = () => {

	return (
		<footer className='container wide margin-top-5'>

			<div className="display-flex justify-content-between align-items-center padding-y-3 border-top font-size-sm">
				<div className='flex-column flex-row--md gap-1'>
					<span>
						&#169; 2023 - Carl Avidano.
					</span>
					<span>
						All Rights Reserved.
					</span> 
				</div>
				<ThemeToggle />
			</div>

		</footer>
	);
};

export default Footer;